var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Modal',{staticClass:"picture-view-components-style",attrs:{"footer-hide":true,"closable":false,"value":_vm.value,"transition-names":['picture-view','fade']},on:{"input":(val)=>_vm.$emit('input',val)}},[_c('img',{staticStyle:{"max-width":"80vw","max-height":"80vh"},attrs:{"src":_vm.src}})])
}
var staticRenderFns = []

export { render, staticRenderFns }